/*
  Product image labels — pill labels attached to the FIRST PDP gallery slide.
  Paired with snippets/product-image-labels.liquid (emits #product-image-labels-data)
  and product-image-labels.css.

  Part of the shoes PDP A/B test — renders for the `dropdown` group only
  (assets/pdp-ab-group.js owns the group; this file just subscribes).

  THE POINT OF THIS FILE: the labels are appended INSIDE the first slide element, not
  overlaid on the gallery viewport. That is what makes them travel with the slide and
  leave the screen as the shopper swipes to image 2 — an overlay on the viewport would
  sit there over every image instead.

  The host must be the element the carousel TRANSLATES, not a wrapper around it — see
  SLIDE_SELECTORS below. GemPages builds its gallery client-side from <gp-product-images>,
  so the slide usually does not exist on first run: a MutationObserver waits for it and
  re-attaches whenever GemPages re-renders.
*/
(function () {
  if (window.__pilBound) return;
  window.__pilBound = true;

  var dataEl = document.getElementById('product-image-labels-data');
  if (!dataEl) return;

  var LABELS;
  try {
    LABELS = (JSON.parse(dataEl.textContent) || {}).labels || [];
  } catch (e) {
    return;
  }
  if (!LABELS.length) return;

  var ATTACHED = 'data-pil-attached';
  var observer = null;
  var scheduled = false;

  /* ---------- slide lookup ---------- */

  // Ordered candidates for THE ELEMENT THAT ACTUALLY MOVES. Getting this wrong is the
  // whole bug: anchoring to a wrapper that merely contains the carousel leaves the labels
  // sitting still while the images slide underneath them.
  //
  //   .gem-slider-item      — GemPages' hydrated slide (also carries gp-relative and
  //                           gp-overflow-hidden, so our absolute pills clip to the image).
  //   .gp-ft-image-item     — marks the FEATURED carousel. Required: the thumbnail strip
  //                           uses the same .gem-slider-item class but .gp-gallery-image-item,
  //                           and labels must never land on a thumbnail.
  //   .gp-feature-image-carousel > .gp-image-item
  //                         — the server-rendered single-image scaffold (product with 1 image,
  //                           where GemPages never builds a slider at all).
  //   .m-product-media--*   — native Minimog: mobile swiper, then desktop grid.
  var SLIDE_SELECTORS = [
    '.gem-slider-item.gp-ft-image-item',
    '.gp-feature-image-carousel .gp-image-item',
    '.m-product-media--slider .m-product-media--item',
    '.m-product-media--list .m-product-media--item',
  ];

  // A thumbnail is never a valid host, whatever else it matches.
  function isThumbnail(node) {
    return node.classList.contains('gp-gallery-image-item');
  }

  function findFirstSlide() {
    for (var i = 0; i < SLIDE_SELECTORS.length; i += 1) {
      var found = document.querySelectorAll(SLIDE_SELECTORS[i]);
      for (var n = 0; n < found.length; n += 1) {
        if (isThumbnail(found[n])) continue;
        // This theme renders separate desktop and mobile galleries and shows one at a
        // time, so the hidden one is in the DOM but has no box — never anchor to it.
        if (!found[n].getClientRects().length) continue;
        // First in DOM order = the first media, which is what the labels are pinned to.
        // Deliberately NOT the active slide: these belong to image 1, not to whatever
        // the shopper has swiped to.
        return found[n];
      }
    }
    return null;
  }

  /* ---------- painting ---------- */

  function buildLabels() {
    var wrap = document.createElement('div');
    wrap.className = 'product-image-labels';
    wrap.setAttribute('data-pil', '');
    for (var i = 0; i < LABELS.length; i += 1) {
      var pill = document.createElement('span');
      pill.className = 'product-label';
      pill.textContent = LABELS[i];
      wrap.appendChild(pill);
    }
    return wrap;
  }

  function detach() {
    var existing = document.querySelectorAll('[data-pil]');
    for (var i = 0; i < existing.length; i += 1) existing[i].remove();
    var hosts = document.querySelectorAll('[' + ATTACHED + ']');
    for (var h = 0; h < hosts.length; h += 1) hosts[h].removeAttribute(ATTACHED);
  }

  function attach() {
    var slide = findFirstSlide();
    if (!slide) return false;
    // Already on the right slide — leave it alone so we never thrash the DOM.
    if (slide.hasAttribute(ATTACHED) && slide.querySelector('[data-pil]')) return true;
    detach();
    // The pills are absolutely positioned; without a positioned host they would escape
    // to the nearest positioned ancestor (or the page) instead of sitting on the image.
    var position = window.getComputedStyle(slide).position;
    if (position === 'static') slide.style.position = 'relative';
    slide.setAttribute(ATTACHED, '');
    slide.appendChild(buildLabels());
    return true;
  }

  /* ---------- group + scheduling ---------- */

  function activeGroup() {
    // Fail safe to control: if the shared resolver did not load, show nothing extra
    // rather than giving every shopper the test experience and spoiling the split.
    if (!window.pdpAb) return 'control';
    return window.pdpAb.refresh();
  }

  function render() {
    scheduled = false;
    if (observer) observer.disconnect();
    if (activeGroup() === 'dropdown') attach();
    else detach();
    if (observer) observer.observe(document.body, { childList: true, subtree: true });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(render, 120);
  }

  function init() {
    observer = new MutationObserver(schedule);
    render();
    if (window.pdpAb && typeof window.pdpAb.onChange === 'function') {
      window.pdpAb.onChange(schedule);
    }
    // Retries for late GemPages hydration — the gallery often is not in the DOM yet.
    [300, 800, 1500, 2500].forEach(function (t) {
      setTimeout(schedule, t);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
